module.exports = __webpack_public_path__ + "img/inboxes-fill.c9cd8c74.svg";